import landingPageContentJson from './landingPageContent.json';
import trackAlshams from '../assets/track-record/alshams.png';
import trackCaribouCoffee from '../assets/track-record/caribou-coffee.jpeg';
import trackWajdLifeTradingCo from '../assets/track-record/wajd-life-trading-co.png';
import partnerGeidea from '../assets/partners/geidea.png';
import partnerTaqaGas from '../assets/partners/taqa-gas.png';
import partnerNiCapital from '../assets/partners/ni-capital.png';
import partnerIdealRatings from '../assets/partners/idealratings.png';
import partnerBdo from '../assets/partners/bdo.png';
import partnerEch from '../assets/partners/ech.png';
import partnerAlFaisalInternational from '../assets/partners/al-faisal-international.png';
import partnerEfgHolding from '../assets/partners/efg-holding.png';
import partnerAmic from '../assets/partners/amic.png';
import partnerSaudiCall from '../assets/partners/saudi-call.png';
import partnerPantherInvestAndAdvisory from '../assets/partners/panther-invest-and-advisory.png';
import partnerNestle from '../assets/partners/nestle.png';
import partnerGskGlaxosmithkline from '../assets/partners/gsk-glaxosmithkline.jpeg';
import partnerMovenpickHotelsResorts from '../assets/partners/movenpick-hotels-resorts.png';
import partnerFincorp from '../assets/partners/fincorp.png';
import partnerBakerTilly from '../assets/partners/baker-tilly.png';
import partnerBritishUniversityEgypt from '../assets/partners/british-university-egypt.png';
import partnerDrillingMaterialsCompany from '../assets/partners/drilling-materials-company.png';
import partnerAlSheikhGroup from '../assets/partners/al-sheikh-group.png';
import type { LucideIcon } from 'lucide-react';
import {
  ArrowRight,
  BarChart3,
  Briefcase,
  Calendar,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Database,
  FileText,
  Heart,
  Lightbulb,
  Lock,
  Mail,
  Menu,
  MessageSquare,
  Moon,
  Phone,
  MapPin,
  Quote,
  Rocket,
  Search,
  Shield,
  Sun,
  Target,
  TrendingUp,
  X,
  LineChart,
} from 'lucide-react';

export const sectionKeys = [
  'hero',
  'partnershipModel',
  'solutionsTailored',
  'visionMission',
  'services',
  'answerEngine',
  'approach',
  'presence',
  'trackRecord',
  'team',
  'trustStrip',
  'insights',
  'testimonials',
  'contact',
  'footer',
] as const;

export type SectionKey = (typeof sectionKeys)[number];

export const landingPageContent = landingPageContentJson;

const imageAssets = {
  trackAlshams,
  trackCaribouCoffee,
  trackWajdLifeTradingCo,
  partnerGeidea,
  partnerTaqaGas,
  partnerNiCapital,
  partnerIdealRatings,
  partnerBdo,
  partnerEch,
  partnerAlFaisalInternational,
  partnerEfgHolding,
  partnerAmic,
  partnerSaudiCall,
  partnerPantherInvestAndAdvisory,
  partnerNestle,
  partnerGskGlaxosmithkline,
  partnerMovenpickHotelsResorts,
  partnerFincorp,
  partnerBakerTilly,
  partnerBritishUniversityEgypt,
  partnerDrillingMaterialsCompany,
  partnerAlSheikhGroup,
} as const;

const imageDimensions: Record<keyof typeof imageAssets, { width: number; height: number }> = {
  trackAlshams: { width: 512, height: 397 },
  trackCaribouCoffee: { width: 840, height: 853 },
  trackWajdLifeTradingCo: { width: 1810, height: 460 },
  partnerGeidea: { width: 1200, height: 675 },
  partnerTaqaGas: { width: 545, height: 336 },
  partnerNiCapital: { width: 1000, height: 500 },
  partnerIdealRatings: { width: 1502, height: 278 },
  partnerBdo: { width: 1500, height: 1500 },
  partnerEch: { width: 1961, height: 1208 },
  partnerAlFaisalInternational: { width: 90, height: 111 },
  partnerEfgHolding: { width: 860, height: 608 },
  partnerAmic: { width: 200, height: 200 },
  partnerSaudiCall: { width: 665, height: 350 },
  partnerPantherInvestAndAdvisory: { width: 540, height: 136 },
  partnerNestle: { width: 781, height: 800 },
  partnerGskGlaxosmithkline: { width: 2362, height: 945 },
  partnerMovenpickHotelsResorts: { width: 1280, height: 421 },
  partnerFincorp: { width: 200, height: 200 },
  partnerBakerTilly: { width: 438, height: 115 },
  partnerBritishUniversityEgypt: { width: 1384, height: 575 },
  partnerDrillingMaterialsCompany: { width: 512, height: 512 },
  partnerAlSheikhGroup: { width: 200, height: 200 },
};

const iconComponents: Record<string, LucideIcon> = {
  arrowRight: ArrowRight,
  barChart3: BarChart3,
  briefcase: Briefcase,
  calendar: Calendar,
  checkCircle: CheckCircle,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronUp: ChevronUp,
  database: Database,
  fileText: FileText,
  heart: Heart,
  lightbulb: Lightbulb,
  lineChart: LineChart,
  lock: Lock,
  mail: Mail,
  mapPin: MapPin,
  menu: Menu,
  messageSquare: MessageSquare,
  moon: Moon,
  phone: Phone,
  quote: Quote,
  rocket: Rocket,
  search: Search,
  shield: Shield,
  sun: Sun,
  target: Target,
  trendingUp: TrendingUp,
  x: X,
};

export function isSectionEnabled(sectionKey: SectionKey) {
  return landingPageContent[sectionKey].enabled;
}

export function getVisibleNavLinks() {
  return landingPageContent.navbar.links.filter((link) =>
    isSectionEnabled(link.sectionKey as SectionKey),
  );
}

export function resolveImageSource(src: string) {
  if (!src.startsWith('asset:')) {
    return src;
  }

  const assetKey = src.slice('asset:'.length) as keyof typeof imageAssets;
  return imageAssets[assetKey] ?? src;
}

export function resolveImageDimensions(src: string) {
  if (!src.startsWith('asset:')) {
    return undefined;
  }

  const assetKey = src.slice('asset:'.length) as keyof typeof imageAssets;
  return imageDimensions[assetKey];
}

export function resolveIconComponent(iconName: string) {
  return iconComponents[iconName] ?? FileText;
}
